import React from 'react';
import { Box, Flex } from '@cardboard-ui/react';
import { FavouriteButton } from 'apps/TenantApp/screens/Favourites/components/FavouriteButton';
import { Status } from '../Status';
import { ShareButton } from '../ShareButton';
import { ItemMenuProps } from '../../ItemMenu';
import { TagButton } from 'apps/TenantApp/components/tags/TagButton';
import { ChatButton } from 'components/ChatButton';

interface ItemOptionButtonsProps extends ItemMenuProps {
  showTags?: boolean;
  showChat?: boolean;
}

export const ItemOptionButtons = ({
  node,
  isUpdatingPage,
  mode,
  showTags = false,
  showChat = false,
}: ItemOptionButtonsProps) => {
  if (!node) return null;
  return (
    <Flex align="center">
      <Box ps={1}>
        <Status node={node} isUpdatingPage={isUpdatingPage} />
      </Box>
      {showTags && <TagButton node={node} ml={1} />}
      {showChat && <ChatButton node={node} iconSize="sm" />}
      <ShareButton node={node} mode={mode} />
      <FavouriteButton node={node} />
    </Flex>
  );
};
